module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/faqs/faqs.component.css
// module id = ./src/app/faqs/faqs.component.css
// module chunks = main